<template>
    <div class="el-container is-vertical" id="tab">
        <div class="el-container content">
            <div class="el-aside">
                <el-card shadow="never">
                    <div slot="header">
                        <span>调整前</span>
                    </div>
                    <el-form :inline="true" class="query_form" size="small">
                        <el-form-item label="客户" prop="customer.selected">
                            <select-multiple class="query_form_item" ref="customer" :select-data="queryForm.customer" :isClear="false" isTable :column-list="selectMultipleTableColumnListCommon.customer" :change="() => { getBalanceAmt('customer', 'salOrderMeet') }" @keydown.enter.right.native="getBalanceAmt('customer', 'salOrderMeet')"></select-multiple>
                        </el-form-item>
                        <el-form-item label="订货会" prop="salOrderMeet.selected">
                            <select-multiple class="query_form_item" ref="salOrderMeet" :select-data="queryForm.salOrderMeet" :isClear="false" :change="() => { getBalanceAmt('salOrderMeet') }" @keydown.enter.right.native="getBalanceAmt('salOrderMeet')" @keydown.left.native="queryFormLeftOrRight($refs.salOrderMeet, $refs.customer)"></select-multiple>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="selectDetail">选择当前余货商品</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <div class="table">
                    <el-table :data="beforeTableData" border stripe size="small" height="100%" max-height="100%" style="width: 100%">
                        <el-table-column width="48">
                            <template slot-scope="scope">
                                <div style="width: 100%;display: flex;flex-direction: row; justify-content: center;">
                                    <el-button icon="el-icon-delete" type="text" @click="deleteRow(scope)" style="margin: 0;"></el-button>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="itemName" label="商品" width="150"></el-table-column>
                        <el-table-column prop="itemSpec" label="规格" width="100"></el-table-column>
                        <el-table-column prop="isLargessFormat" label="销售形式" width="100"></el-table-column>
                        <el-table-column prop="onhandQtyFormat" label="待还数量" width="100"></el-table-column>
                        <el-table-column prop="onhandAmt" label="待还金额" width="100"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="el-main">
                <el-card shadow="never">
                    <div slot="header">
                        <span>调整后</span>
                    </div>
                </el-card>
                <div class="el-container">
                    <el-aside :width="isCollapse ? '20px' : '240px'">
                        <el-card v-show="!isCollapse" class="box-card" shadow="never">
                            <div slot="header">
                                <span>商品类别</span>
                                <el-button style="float: right; padding: 3px 0;" icon="el-icon-d-arrow-left" type="text" @click="showCollapse"></el-button>
                            </div>
                            <order-cascader ref="orderCascader" :product-params="{customerID: queryitem.customerID}" :billType="'DHD'" @get-product-data="getProductData">
                                <template v-slot="{ row, node }">
                                    <span v-if="row.text.length < 7 && (row.type == 'PP' || !node.isLeaf || row.type == '')" class="cascader_text">{{ row.text }}</span>
                                    <el-popover v-else :ref="row.value" popper-class="cascader_popper" trigger="hover" placement="right">
                                        <span v-if="row.type == 'PP'">{{ row.text }}</span>
                                        <div v-else style="width: auto; min-height: 100px; max-height: 400px;" v-loading="!row.isHasPromotionData">
                                            <div v-if="row.isHasPromotionData">
                                                <div>
                                                    <el-row :gutter="20">
                                                        <el-col :span="6">
                                                            <label>促销方案:</label><span>{{row.planInfo.planDesc}}</span>
                                                        </el-col>
                                                        <el-col :span="6">
                                                            <label>开始日期:</label><span>{{row.planInfo.beginDate}}</span>
                                                        </el-col>
                                                        <el-col :span="6">
                                                            <label>结束日期:</label><span>{{row.planInfo.endDate}}</span>
                                                        </el-col>
                                                        <el-col :span="6">
                                                            <label>起始数量:</label><span>{{row.planInfo.segments}}</span>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                                <div class="cascader_table">
                                                    <el-table :data="row.itemList" border height="100%" max-height="100%" style="width: 100%">
                                                        <el-table-column type="index"></el-table-column>
                                                        <el-table-column prop="itemName" label="商品" width="180"></el-table-column>
                                                        <el-table-column prop="productionDate" label="生产日期" width="100"></el-table-column>
                                                        <el-table-column prop="isLargessFormat" label="是否赠品" width="80"></el-table-column>
                                                        <el-table-column label="单位名称" width="90">
                                                            <template slot-scope="scope">
                                                                <span v-show="scope.row.salUnitName">{{scope.row.salUnitName}}</span>
                                                                <span v-show="scope.row.midUnitName">{{scope.row.midUnitName}}</span>
                                                                <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitName}}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="促销价格">
                                                            <template slot-scope="scope">
                                                                <span v-show="scope.row.salUnitName">{{scope.row.salUnitPrice}}</span>
                                                                <span v-show="scope.row.midUnitName">{{scope.row.midUnitPrice}}</span>
                                                                <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitPrice}}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="赠品数量">
                                                            <template slot-scope="scope">
                                                                <span v-show="scope.row.salUnitName">{{scope.row.salUnitQty}}</span>
                                                                <span v-show="scope.row.midUnitName">{{scope.row.midUnitQty}}</span>
                                                                <span v-show="scope.row.salUnitConversion != 1 && scope.row.invUnitName">{{scope.row.invUnitQty}}</span>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                    <el-row :gutter="20" style="margin-bottom: 0; margin-top: 10px;">
                                                        <el-col :span="12">
                                                            <span>倍数:</span>
                                                            <el-input-number v-model="row.multiple" controls-position="right" :min="1" :step="1" step-strictly size="small" @change="promotionInputChange($event, row)"></el-input-number>
                                                        </el-col>
                                                        <el-col :span="12">
                                                            <el-button type="primary" size="small" @click="addProductToOrder(row, true)">添加全部商品到单据</el-button>
                                                        </el-col>
                                                    </el-row>
                                                </div>
                                            </div>
                                        </div>
                                        <span slot="reference" class="cascader_text" @mouseenter="row.type == 'CX' ? getPromotion(row) : () => {}">{{ row.text }}</span>
                                    </el-popover>
                                </template>
                            </order-cascader>
                        </el-card>
                        <div class="isCollapse" v-show="isCollapse" @click="showCollapse">
                            <span style="text-align: center;">商品</span>
                            <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
                            <span style="text-align: center;">类别</span>
                        </div>
                    </el-aside>
                    <div class="el-main">
                        <query-form ref="queryFormRef" :from="queryitem" class="query" @getQueryForm="getQueryForm"></query-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="el-footer">
            <el-card shadow="never">
                <div class="footer-left">
                    <p>调整前金额:{{ selection.amt }}元，调整后金额:{{ selection.adjustAmt }}元，相差{{ selection.prePayAmt || 0 }}元。</p>
                    <p>注：调整前后差额自动转为欠款或预收款。</p>
                </div>
                <div class="footer-right">
                    <el-form :inline="true" class="footer_form" size="small">
                        <el-form-item label="业务员" prop="salesman.selected">
                            <select-multiple class="query_form_item" ref="salesman" :change="() => { getNext('', 'brand') }" :select-data="queryForm.salesman" :isClear="false"></select-multiple>
                        </el-form-item>
                        <el-form-item label="品牌" prop="brand.selected">
                            <select-multiple class="query_form_item" ref="brand" :change="() => { getNext('', 'prePayAmt') }" :select-data="queryForm.brand" :isClear="false"></select-multiple>
                        </el-form-item>
                        <el-form-item label="形成预收" prop="prePayAmt.selected">
                            <el-input-number class="footer-number" ref="prePayAmt" @blur="getNext($event, 'remark')" @focus="getFocus($event, 'prePayAmt')" v-model="queryForm.prePayAmt.selected" placeholder="请输入预收" :controls="false" :precision="2"></el-input-number>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark.selected">
                            <el-input v-model="queryForm.remark.selected" ref="remark" placeholder="请输入备注"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="toSubmit">提交审核</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </div>
        <el-dialog title="选择当前余货商品" width="86%" :visible.sync="dialogTableVisible" custom-class="dialogTable" :close-on-click-modal="false" destroy-on-close @close="dialogClose" @open="dialogOpen">
            <el-card class="box-card-query" shadow="never">
                <el-form :inline="true" size="small">
                    <el-form-item>
                        <!-- <date-picker style="width: 100%;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                        </date-picker> -->
                    </el-form-item>
                    <el-form-item>
                        <!-- <el-button type="primary" @click="selectDetail">查询</el-button> -->
                    </el-form-item>
                    <el-form-item style="float: right;">
                        <el-button type="success" @click="onSelect">确定</el-button>
                    </el-form-item>
                    <el-form-item style="float: right; color: #F56C6C;">
                        <span>选中：</span>
                        <span style="margin-right: 6px;">{{ selection.length }}条，</span>
                        <span>合计金额：</span>
                        <span>{{ selection.amt }}元</span>
                    </el-form-item>
                </el-form>
            </el-card>
            <div class="dialog-table" v-loading="dialogTableLoading">
                <el-table ref="dialogTable" :data="dialogTableData" style="width: 100%" border stripe height="100%" max-height="100%" row-key="billNo" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
                    <el-table-column type="index" width="55" align="center"></el-table-column>
                    <el-table-column prop="itemName" label="商品" min-width="180px" align="center"></el-table-column>
                    <el-table-column prop="itemSpec" label="规格" width="110" align="center"></el-table-column>
                    <el-table-column prop="isLargessFormat" label="销售形式" width="110" align="center"></el-table-column>
                    <el-table-column prop="onhandQtyFormat" label="待还数量" min-width="120px" align="center"></el-table-column>
                    <el-table-column prop="onhandAmt" label="待还金额" min-width="120px" align="center"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import queryForm from '@/components/saleManage/salOrderMeet/orderEntering.vue'
import orderCascader from '@/components/saleManage/salOrderMeet/orderCascader.vue'
import { pickerOptions, toRawType, getResultArray, toFixedRe } from '@/assets/js/common.js'
import { queryFormLeftOrRight } from '@/assets/js/orderEntering.js'
export default {
    components: {
        queryForm,
        orderCascader
    },
    name: 'SalOrderItemChange',
    mixins: [selectMultipleTableColumnListCommonMixins],
    data() {
        return {
            queryForm: {
                customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                salOrderMeet: { submitName: 'salOrderMeet', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择订货会', request: { url: '/Account/dataSearchVue/selectOrderMeetForVue.html', type: 'post', params: { page: 1, size: 10, orderMeetType: 'A' }, text: '', value: '' } },
                salesman: { submitName: 'salesman', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
                remark: { submitName: 'remark', selected: '' },
                brand: { submitName: 'brand', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: { page: 1, size: 5, isEnabled: 'Y' }, text: '', value: '' } },
                billDate: { submitName: 'billDate', selected: [] },
                prePayAmt: { submitName: 'prePayAmt', selected: 0 }
            },
            pickerOptions: pickerOptions,
            beforeTableData: [],
            dialogTableVisible: false,
            dialogTableLoading: false,
            dialogTableData: [],
            dialogTableSum: {},
            tableData: [],
            selection: {
                length: 0,
                amt: 0,
                adjustAmt: 0,
                prePayAmt: 0
            },
            isCollapse: true,
            itemParams: {
                firstValue: '',
                secondValue: ''
            }
        }
    },
    computed: {
        queryitem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (toRawType(item.selected) == 'Array') {
                    if (item.submitName == 'billDate') {
                        tempItem['beginDate'] = item.selected[0] || ''
                        tempItem['endDate'] = item.selected[1] || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                } else if (toRawType(item.selected) == 'Object') {
                    if (['salOrderMeet', 'customer', 'brand', 'salesman'].includes(item.submitName)) {
                        tempItem[item.submitName + 'ID'] = item.selected.value || ''
                        tempItem[item.submitName + 'Name'] = item.selected.text || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.value || ''
                } else {
                    if (item.selected) tempItem[item.submitName] = item.selected
                }
            })
            return tempItem
        },
    },
    mounted() {
        this.$refs['customer'].focus()
    },
    methods: {
        queryFormLeftOrRight(selfRef, nextOrPrevRef) {
            queryFormLeftOrRight(selfRef, nextOrPrevRef)
        },
        async getBalanceAmt(tag, next) {
            this.$refs[tag].$children[0].blur()
            if (tag == 'customer') {
                console.log(tag)
                this.$refs.orderCascader.getBrandData()
            } else if (tag == 'salOrderMeet') {
                this.$refs['queryFormRef'].getProductData()
            }
            if (next) {
                this.$nextTick(() => {
                    this.$refs[next].focus()
                })
            }
            this.$refs.queryFormRef.tableData = this.$refs.queryFormRef.pushItem()
            this.beforeTableData = []
            this.selection.amt = 0
            this.selection.length = 0
            this.selection.adjustAmt = 0
            this.selection.prePayAmt = 0
            this.queryForm.prePayAmt.selected = 0
            this.getQuerySalesman()
        },
        async getNext(e, tag) {
            if (tag) {
                this.$nextTick(() => {
                    this.$refs[tag].focus()
                })
            }
        },
        getFocus(e, tag) {
            this.$nextTick(() => {
                this.$refs[tag].select()
            })
        },
        async getQuerySalesman() {
            if (this.queryitem.customerID && this.queryitem.salOrderMeetID) {
                const { data: res } = await this.$http.post('/Account/salOrderMeetVue/querySalesman.html', this.Qs.stringify({ customerID: this.queryitem.customerID, salOrderMeetID: this.queryitem.salOrderMeetID }))
                if (res.code != 'success') return
                let result = JSON.parse(res.result)
                let data = JSON.parse(result.data)
                if (data) {
                    this.queryForm.salesman.selected = {
                        value: data.salesmanID,
                        text: data.salesmanName
                    }
                } else {
                    this.queryForm.salesman.selected = {}
                }
            }
        },
        async getPromotion(row) {
            let { isHasPromotionData, value } = row
            if (isHasPromotionData) return
            const { data: res } = await this.$http.post('/Account/salConsignVue/selectPromotionItemDetail.html', this.Qs.stringify({ planID: value }))
            if (res.code != 'success') return
            const { planInfo, itemList } = JSON.parse(JSON.parse(res.result).data)
            this.$set(row, 'isHasPromotionData', true)
            this.$set(row, 'multiple', 1)
            this.$set(row, 'planInfo', planInfo)
            this.$set(row, 'itemList', itemList)
        },
        promotionInputChange(val, { value }) {
            console.log(value)
            this.$nextTick(() => {
                this.$refs[value].doShow()
            })
        },
        // 添加全部商品到单据
        addProductToOrder({ itemList, multiple }, isPromotion) {
            multiple = Number(multiple || 0)
            if (this.queryitem.customerID == '') return this.$message({
                showClose: true,
                message: '请先选择客户',
                type: 'warning'
            })
            if (this.queryitem.salOrderMeet == '') return this.$message({
                showClose: true,
                message: '请先选择订货会',
                type: 'warning'
            })
            const sal = this.$refs.queryFormRef
            let tableData = [...sal.tableData].reverse()
            let length = tableData.length
            this.$nextTick(() => {
                tableData.some((item, index) => {
                    if (item.itemID) {
                        itemList.map((row, $index) => {
                            let tempItem = {}
                            tempItem.salUnitQty = Number(toFixedRe((Number(row.salUnitQty) * multiple), 2))
                            tempItem.midUnitQty = Number(toFixedRe((Number(row.midUnitQty) * multiple), 2))
                            tempItem.invUnitQty = Number(toFixedRe((Number(row.invUnitQty) * multiple), 2))
                            tempItem.totalAmt = Number(toFixedRe((Number(sal.amt({ row: row })) * multiple), 2))
                            this.$set(sal.tableData, length - index + $index, { ...row, ...tempItem })
                        })
                        return true
                    }
                    if ((sal.tableData.length - 1) == index) {
                        itemList.map((row, $index) => {
                            let tempItem = {}
                            tempItem.salUnitQty = Number(toFixedRe((Number(row.salUnitQty) * multiple), 2))
                            tempItem.midUnitQty = Number(toFixedRe((Number(row.midUnitQty) * multiple), 2))
                            tempItem.invUnitQty = Number(toFixedRe((Number(row.invUnitQty) * multiple), 2))
                            tempItem.totalAmt = Number(toFixedRe((Number(sal.amt({ row: row })) * multiple), 2))
                            this.$set(sal.tableData, $index, { ...row, ...tempItem })
                        })
                        return true
                    }
                })
                let amt = 0
                this.$refs.queryFormRef.tableData.forEach(item => {
                    if (item.totalAmt) {
                        amt += item.totalAmt
                    }
                })
                this.getQueryForm({ adjustAmt: amt })
            })
        },
        getQueryForm(e) {
            // console.log(e, 23232)
            this.selection.adjustAmt = e.adjustAmt
            this.selection.prePayAmt = this.queryForm.prePayAmt.selected = Number(toFixedRe(Number(this.selection.amt) - Number(this.selection.adjustAmt), 2))
        },
        async selectDetail() {
            console.log(this.queryitem)
            if (this.queryitem.customerID == '') return this.$message.warning('请先选择客户')
            if (this.queryitem.salOrderMeetID == '') return this.$message.warning('请先选择订货会')
            this.dialogTableVisible = true
            this.dialogTableLoading = true
            let data = await this.getDetail()
            this.dialogTableLoading = false
            this.dialogTableData = data
            this.$nextTick(() => {
                this.beforeTableData.forEach(item => {
                    this.dialogTableData.forEach(it => {
                        if (it.itemID == item.itemID) {
                            this.$refs.dialogTable.toggleRowSelection(it, true)
                        }
                    })
                })
            })
        },
        async getDetail() {
            const { data: res } = await this.$http.post('/Account/salOrderMeetVue/queryMeetItemMasterList.html', this.Qs.stringify(this.queryitem))
            if (res.code != 'success') return this.$message.error(res.message)
            let data = JSON.parse(res.result)
            console.log(data)
            return data ? data : []
        },
        dialogOpen() {
            this.handleSelectionChange(this.beforeTableData)
            this.selection.length = 0
            this.selection.amt = 0
        },
        dialogClose() {
            this.dialogTableData = []
        },
        deleteRow({ $index }) {
            this.beforeTableData.splice($index, 1)
            let amt = 0
            this.selection.length = this.beforeTableData.length
            this.beforeTableData.forEach((i) => {
                amt += Number(i.onhandAmt)
            })
            this.selection.amt = Number(toFixedRe(amt, 2))
            this.selection.prePayAmt = this.queryForm.prePayAmt.selected = Number(toFixedRe(Number(this.selection.amt) - Number(this.selection.adjustAmt), 2))
        },
        handleSelectionChange(selection) {
            this.selection.length = selection.length
            let amt = 0
            selection.forEach((i) => {
                amt += Number(i.onhandAmt)
            })
            this.selection.amt = Number(toFixedRe(amt, 2))
            this.selection.prePayAmt = this.queryForm.prePayAmt.selected = Number(toFixedRe(Number(this.selection.amt) - Number(this.selection.adjustAmt), 2))
        },
        onSelect() {
            const keys = (i) => {
                return i.itemID + i.isLargessFormat
            }
            let add = getResultArray(keys, 'd', this.$refs['dialogTable'].selection, this.beforeTableData)
            let detele = getResultArray(keys, 'd', this.beforeTableData, this.$refs['dialogTable'].selection)
            if (detele.length) {
                detele.forEach(i => {
                    this.beforeTableData = this.beforeTableData.filter(j => i.itemID != j.itemID)
                })
            }
            if (add.length) {
                this.beforeTableData = this.beforeTableData.concat(add)
            }
            this.dialogTableVisible = false
            // console.log(this.selection)
        },
        getProductData(e) {
            this.itemParams = e
            console.log(this.$refs.queryFormRef)
            if (this.$refs.queryFormRef) {
                let item = this.$refs.queryFormRef.itemName.request.params
                this.$refs.queryFormRef.itemName.request.params = { ...item, ...e }
            }
        },
        showCollapse() {
            this.isCollapse = !this.isCollapse
            this.$refs.queryFormRef.getHeight()
        },
        async toSubmit() {
            if (this.beforeTableData.length == 0) return this.$message.error('请输入调整前商品')
            let itemMasterInfo = this.$refs.queryFormRef.tableData.filter(item => item.itemID)
            if (itemMasterInfo.length == 0) return this.$message.error('请输入调整后商品')
            if (this.queryitem.salesmanID == '') return this.$message.warning('请先选择业务员')
            if (this.queryitem.brandID == '') return this.$message.warning('请先选择品牌')
            let flag = false
            let tableData = []
            this.$refs.queryFormRef.tableData.map((i, index) => {
                if (i.itemID) {
                    tableData.push(i)
                }
            })
            // tableData.some(item => {
            //     const { itemID, salUnitQty, midUnitQty, invUnitQty, lineNum } = item
            //     console.log(itemID, salUnitQty, midUnitQty, invUnitQty)
            //     if (itemID && Number(salUnitQty) + Number(midUnitQty) + Number(invUnitQty) == 0) {
            //         this.$message({
            //             showClose: true,
            //             message: '第' + lineNum + '行,商品数量不能为零',
            //             type: 'error'
            //         })
            //         flag = true
            //         return true
            //     }
            // })
            // if (flag) return
            this.queryitem.itemMasterInfoBefore = JSON.stringify(this.beforeTableData)
            this.queryitem.itemMasterInfo = JSON.stringify(itemMasterInfo)
            // this.queryitem.prePayAmt = this.selection.prePayAmt
            let currTab = '',
                title = ''
            if (top.$('#tabspanel .tabs-selected').text()) {
                currTab = top.$('#tabspanel').tabs('getSelected') || ''
                title = top.$('#tabspanel .tabs-selected').text() || ''
            } else {
                title = top.getTabName()
                currTab = top.getTabName()
            }
            const loading = this.$loading({
                lock: true,
                text: '提交中,请等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const { data: res } = await this.$http.post('/Account/salOrderItemVue/updateOrderMeetChange.html', this.Qs.stringify(this.queryitem))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            setTimeout(() => {
                top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/salOrderItemChange`, currTab)
            }, 500)
        }
    }
}
</script>
<style scoped lang="less">
#tab {

    .content {
        height: calc(100% - 100px - 2px);
    }

    &>.el-container>.el-aside {
        width: 500px;

        ::v-deep .el-card {
            .el-card__header {
                padding: 8px 20px;
                height: 33px;
                background-color: #F5F7FA;
                color: #409EFF;
                font-size: 14px;
            }

            .el-card__body {
                padding: 12px;

                .el-form {
                    display: flex;
                    height: 100%;

                    .el-scrollbar {
                        height: 100%;
                    }

                    .el-form-item {
                        margin: 0 10px 0 0;
                        position: relative;

                        .el-form-item__label {
                            position: absolute;
                            z-index: 2;
                            top: -12px;
                            margin-left: 10px;
                            padding: 0 6px;
                            line-height: normal;
                            background-color: #fff;
                            color: #000;
                        }

                        .amt-info {
                            border: 1px #F56C6C solid;
                            color: #F56C6C;

                            span {
                                display: block;
                                text-align: center;
                            }
                        }
                    }
                }

                .calculation-form {
                    .el-form-item {
                        text-align: center;

                        .el-form-item__label {
                            margin: 0;
                            left: 36px;
                        }

                        .input-with-select {
                            .el-input-group__prepend {
                                padding: 0 12px;
                                background-color: #fff;

                                .select-multiple {
                                    display: inline-block;
                                    width: 50px;
                                }
                            }
                        }

                        .el-input-number .el-input__inner {
                            text-align: left;
                        }
                    }
                }
            }
        }

        .select_multiple {
            ::v-deep .el-select__tags {
                max-height: 80px;
                overflow-y: auto;
                overflow-x: hidden;
            }
        }

        .table {
            height: calc(100% - 57px - 33px - 2px);

            /deep/.cell {
                font-size: 14px;
            }

            /deep/.el-table--small .el-table__cell {
                padding: 0;
                height: 48px;
            }
        }
    }

    &>.el-container>.el-main {
        padding: 0 0 0 12px;

        ::v-deep .el-card {
            .el-card__header {
                padding: 8px 20px;
                height: 33px;
                background-color: #F5F7FA;
                color: #409EFF;
                border-bottom: none;
            }

            .el-card__body {
                padding: 0;
            }
        }

        .el-container {
            height: calc(100% - 33px - 2px);

            .el-aside {
                width: 300px;
                border-top: none;
                height: 100%;
            }

            .el-main {
                padding: 0;
                height: 100%;

                .query {
                    height: 100%;
                }
            }
        }
    }

    .el-footer {
        height: 100px;
        padding: 0;

        /deep/.el-card {
            margin-top: 12px;
            height: calc(100% - 2px - 12px);

            .el-card__body {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 12px;
                height: calc(100% - 20px);
            }

            .footer-left {
                width: 30%;

                p {
                    color: #F56C6C;
                    font-size: 14px;
                }
            }

            .footer-right {
                width: 70%;

                .footer_form {

                    .el-form-item.el-form-item--small {
                        margin-bottom: 0;
                    }

                    .footer-number {
                        .el-input__inner {
                            padding: 0 5px;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    .isCollapse {
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        border: 1px #DCDFE6 solid;
        cursor: pointer;
        background-color: rgba(83, 168, 255, 0.1);
        color: #409EFF;
    }

    /deep/.box-card {
        height: calc(100% - 2px);

        .el-cascader-panel.is-bordered {
            border: none;
        }

        .el-card__header {
            padding: 8px 20px;
        }

        .el-card__body {
            padding: 0;
            height: calc(100% - 37px);
        }

        .el-card__body>div {
            height: 100%;
        }

        .el-cascader-panel {
            width: 100%;
            height: 100%;
            display: flex;
        }

        .el-cascader-menu {
            flex: 1;
            min-width: 0;
        }

        .el-cascader-menu__wrap {
            height: 100%;
            overflow-x: hidden;
        }

        .el-cascader-node {
            padding: 0 12px;
        }

        .el-cascader-node__label {
            width: 100%;
            height: 100%;
            padding: 0;
        }

        .cascader_text {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .el-cascader-panel .el-icon-check:before {
            content: '';
        }

        .el-cascader-node__postfix {
            display: none;
        }

        .cascader_popper .el-row {
            margin-bottom: 10px;
        }

        .cascader_popper .el-col label {
            width: 60px;
            display: inline-block;
            text-align: right;
            margin-right: 6px;
        }

        .cascader_table {
            margin-top: 12px;
            height: 280px;
        }

        .badge {
            position: absolute;
            right: 6px;
        }
    }

    ::v-deep .el-dialog {
        height: 86vh;
        min-width: 1000px;

        .el-dialog__body {
            height: calc(100% - 54px);
            padding-top: 0;
            box-sizing: border-box;
            display: flex;
            flex-flow: column;

            .dialog-table {
                height: calc(100% - 48px);
            }

            .box-card-query {
                .el-card__body {
                    padding: 6px;
                }

                .el-form {
                    .el-form-item {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

    .border {
        border-top: 1px #E4E7ED solid;
    }

    .cell-p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>